import Ansar from 'assets/images/banks/b_ansar.png'
import Ayande from 'assets/images/banks/b_ayande.png'
import Day from 'assets/images/banks/b_dey.png'
import EghtesadNovin from 'assets/images/banks/b_eghtesad_novin.png'
import Gardeshgari from 'assets/images/banks/b_gardeshgari.png'
import Ghavvamin from 'assets/images/banks/b_ghavamin.png'
import Hekmat from 'assets/images/banks/b_hekmat.png'
import IranVanazoela from 'assets/images/banks/b_iran_venezuela.png'
import IranZamin from 'assets/images/banks/b_iranzamin.png'
import Karafarin from 'assets/images/banks/b_karafarin.png'
import Keshavarzi from 'assets/images/banks/b_keshavarzi.png'
import Khavarmiane from 'assets/images/banks/b_khavarmiane.png'
import Maskan from 'assets/images/banks/b_maskan.png'
import MehreEghtesad from 'assets/images/banks/b_mehr_eqtesad.png'
import MehrIran from 'assets/images/banks/b_mehr_iran.png'
import Mellat from 'assets/images/banks/b_mellat.png'
import Melli from 'assets/images/banks/b_melli.png'
import Parsian from 'assets/images/banks/b_parsian.png'
import Pasargad from 'assets/images/banks/b_pasargad.png'
import Refah from 'assets/images/banks/b_refah.png'
import Resalat from 'assets/images/banks/b_resalat.png'
import Saderat from 'assets/images/banks/b_saderat.png'
import Saman from 'assets/images/banks/b_saman.png'
import SanatMadan from 'assets/images/banks/b_sanat_madan.png'
import Sarmaye from 'assets/images/banks/b_sarmaye.png'
import Sepah from 'assets/images/banks/b_sepah.png'
import Shahar from 'assets/images/banks/b_shahr.png'
import Sina from 'assets/images/banks/b_sina.png'
import Taavon from 'assets/images/banks/b_taavon.png'
import Tejarat from 'assets/images/banks/b_tejarat.png'
import ToseeSaderat from 'assets/images/banks/b_tosee_saderat.png'
import Askariyeh from 'assets/images/banks/io_askarie.png'
import EtebarTosee from 'assets/images/banks/io_etebari_tose.png'
import Kosar from 'assets/images/banks/io_kosar.png'
import Samen from 'assets/images/banks/io_samen.png'
import Parsian2 from 'assets/images/banks/parsian.png'
export const BankConvertor: { [key: string]: string } = {
    b_ansar: Ansar,
    b_ayande: Ayande,
    b_dey: Day,
    b_eghtesad_novin: EghtesadNovin,
    b_gardeshgari: Gardeshgari,
    b_ghavamin: Ghavvamin,
    b_hekmat: Hekmat,
    b_iran_venezuela: IranVanazoela,
    b_iranzamin: IranZamin,
    b_karafarin: Karafarin,
    b_keshavarzi: Keshavarzi,
    b_khavarmiane: Khavarmiane,
    b_maskan: Maskan,
    b_mehr_eqtesad: MehreEghtesad,
    b_mehr_iran: MehrIran,
    b_mellat: Mellat,
    b_melli: Melli,
    b_parsian: Parsian,
    b_pasargad: Pasargad,
    b_refah: Refah,
    b_resalat: Resalat,
    b_saderat: Saderat,
    b_saman: Saman,
    b_sanat_madan: SanatMadan,
    b_sarmaye: Sarmaye,
    b_sepah: Sepah,
    b_shahr: Shahar,
    b_sina: Sina,
    b_taavon: Taavon,
    b_tejarat: Tejarat,
    b_tosee_saderat: ToseeSaderat,
    io_askarie: Askariyeh,
    io_etebari_tose: EtebarTosee,
    io_kosar: Kosar,
    io_samen: Samen,
    parsian: Parsian2,
}
